export default __webpack_public_path__ + "static/media/desktop-image-hero-2.9d354056.jpg";